import React from 'react';
export function PrintIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.292 12.283a1 1 0 101.415 1.413 1 1 0 00-1.415-1.413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9.01h-1l.008-5a2 2 0 00-2-2l-8-.012a2 2 0 00-2 2L6 8.991H5a3 3 0 00-3 2.995l-.007 5a3.006 3.006 0 003 3h1.182a2.965 2.965 0 002.815 2l6 .008h.006a3 3 0 002.814-2H19a3.006 3.006 0 003-3l.007-5A3 3 0 0019 9.01zM8.012 3.994l8 .011-.008 5L8 8.994l.012-5zM14.99 20l-6-.008a1 1 0 110-2l6 .008a1 1 0 110 2zm5-2.993a1.006 1.006 0 01-1 1h-1.183a3 3 0 00-2.813-2l-6-.008h-.005a2.969 2.969 0 00-2.816 2H4.992a1.006 1.006 0 01-1-1l.007-5a1 1 0 011-1H5l14 .02a1 1 0 011 1l-.01 4.988z"
  }));
}